import * as types from '../constants/ActionTypes';

export const initialState = {
    sharedExcercisesByFather: {
        publicTitle: '',
        relatedItems: []
    },
    loaded: false
};

export default function relatedItems(state = initialState, action = {}) {
    switch (action.type) {
        case types.FETCH_EXERCISES_BY_RELATED_FATHER_SUCCESS:
            return {
                ...state,
                sharedExcercisesByFather: action.result,
                loaded: true
            };
        case types.FETCH_EXERCISES_BY_RELATED_FATHER_FAILURE:
            return {
                sharedExcercisesByFather: {
                    publicTitle: '',
                    relatedItems: []
                },
                loaded: true
            };
        default:
            return state;
    }
}
